import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import classnames from 'classnames';

import Typography, { TypographyProps } from './Typography';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
    },
    marginLeft: {
      marginLeft: unit,
    },
    extraMarginLeft: {
      marginLeft: unit * 1.5,
    },
    marginRight: {
      marginRight: unit,
    },
    extraMarginRight: {
      marginRight: unit * 1.5,
    },
  });

export interface TypographyWithIconProps extends Omit<TypographyProps, 'classes'>, WithStyles<typeof styles> {
  icon: React.ReactElement;
  iconPlacement?: 'start' | 'end';
  extraMargin?: boolean;
}

const TypographyWithIcon: React.FC<TypographyWithIconProps> = ({
  classes,
  children,
  icon,
  iconPlacement = 'start',
  extraMargin,
  ...rest
}) => (
  <Typography className={classes.root} {...rest}>
    {iconPlacement === 'start' && icon}
    <Typography
      className={classnames({
        [extraMargin ? classes.extraMarginLeft : classes.marginLeft]: iconPlacement === 'start',
        [extraMargin ? classes.extraMarginRight : classes.marginRight]: iconPlacement === 'end',
      })}
      variant="inherit"
      inline
    >
      {children}
    </Typography>
    {iconPlacement === 'end' && icon}
  </Typography>
);

export default withStyles(styles)(TypographyWithIcon);
